import { action } from "typesafe-actions";
import { Workstation, WorkstationActionTypes, Data } from "./types";

export const fetchRequest = (
  id: string | null,
  params?: {},
  callback?: () => unknown
) => action(WorkstationActionTypes.FETCH, { id, params, callback });

export const fetchSuccess = (data: Workstation) =>
  action(WorkstationActionTypes.FETCH_SUCCESS, data);

export const fetchError = (error: string) =>
  action(WorkstationActionTypes.FETCH_ERROR, error);

export const saveRequest = (
  data: Data,
  callback?: (err: string | null, data: Workstation | null) => unknown
) => action(WorkstationActionTypes.SAVE_REQUEST, { data, callback });

export const saveSuccess = (data: Workstation) =>
  action(WorkstationActionTypes.SAVE_SUCCESS, data);

export const saveError = (error: string) =>
  action(WorkstationActionTypes.SAVE_ERROR, error);

export const deleteRequest = (
  id: string,
  callback?: (error: string | null) => unknown
) => action(WorkstationActionTypes.DELETE_REQUEST, { id, callback });

export const deleteSuccess = () => action(WorkstationActionTypes.DELETE_SUCCESS);

export const deleteError = (error: string) =>
  action(WorkstationActionTypes.DELETE_ERROR, error);
